let active = false

export function setStatsActive (value) {
  active = !!value
}

export function isStatsActive () {
  return active
}
